<template>
  <div class="flex h-screen row-auto">
    <SidebarComponent />

    <div class="flex-grow overflow-y-auto bg-[#f9fafb]">
      <div
        class="relative min-h-screen text-white flex flex-col bg-[#007CEF] bg-cover bg-center bg-no-repeat bg-blend-overlay"
        :style="{ backgroundImage: `url(${backgroundImage})` }"
      >
        <div class="mt-4 mx-5">
          <p class="font-bold">
            {{ t("ranking.title") }}
          </p>
          <div
            class="bg-white/20 p-1 rounded-[100px] mt-4 h-[46px] flex gap-4 items-center overflow-hidden relative"
          >
            <div
              class="absolute top-1 left-1 h-[38px] w-[calc(50%-8px)] bg-white rounded-[100px] transition-all duration-300"
              :class="
                activeTab === 'weekly'
                  ? 'translate-x-0'
                  : 'translate-x-[calc(100%+8px)]'
              "
            />
            <button
              class="w-full z-10 h-[38px] flex items-center justify-center font-semibold text-sm transition-all duration-200 rounded-[100px]"
              :class="activeTab === 'weekly' ? 'text-[#007CEF]' : 'text-white'"
              @click="activeTab = 'weekly'"
            >
              {{ t("ranking.tabs.weekly") }}
            </button>
            <button
              class="w-full z-10 h-[38px] flex items-center justify-center font-semibold text-sm transition-all duration-200 rounded-[100px]"
              :class="activeTab === 'alltime' ? 'text-[#007CEF]' : 'text-white'"
              @click="activeTab = 'alltime'"
            >
              {{ t("ranking.tabs.allTime") }}
            </button>
          </div>
          <div class="mt-4 w-full text-center">
            <p
              v-if="activeTab === 'weekly'"
              class="font-semibold"
            >
              {{ t("ranking.banner.weeklyChampion") }}
            </p>
            <p
              v-else
              class="font-semibold"
            >
              {{ t("ranking.banner.allTime") }}
            </p>
          </div>
        </div>

        <div class="flex gap-[22px] mx-auto mt-[35px]">
          <div
            v-if="leaderboardData[1]"
            class="mt-[64px]"
          >
            <div class="relative w-fit mx-auto">
              <img
                :src="top2"
                class="w-[14px] absolute top-[35px] left-1/2 -translate-x-1/2 z-10"
              >
              <img
                :src="avatarNumber1"
                class="w-[56px] mx-auto relative z-0"
              >
              <p class="font-medium text-sm text-center">
                {{ leaderboardData[1].Name }}
              </p>
              <p class="font-medium text-[12px] text-center text-[#29FD88]">
                {{ leaderboardData[1].XP }} {{ t("dashboard.xpLabel") }}
              </p>
            </div>
            <div
              class="w-[100px] h-[320px] bg-gradient-to-b from-[#146DBF] to-[#04427C] rounded-[14px] mt-[12px]"
            />
          </div>

          <div v-if="leaderboardData[0]">
            <div class="relative w-fit mx-auto">
              <img
                :src="crown"
                class="w-[32px] absolute top-[-19px] left-1/2 -translate-x-1/2 z-10"
              >
              <img
                :src="top1"
                class="w-[14px] absolute top-[35px] left-1/2 -translate-x-1/2 z-10"
              >
              <img
                :src="avatarNumber1"
                class="w-[56px] mx-auto relative z-0"
              >
              <p class="font-medium text-sm text-center">
                {{ leaderboardData[0].Name }}
              </p>
              <p class="font-medium text-[12px] text-center text-[#29FD88]">
                {{ leaderboardData[0].XP }} {{ t("dashboard.xpLabel") }}
              </p>
            </div>
            <div
              class="w-[100px] h-[361px] bg-gradient-to-b from-[#146DBF] to-[#04427C] rounded-[14px] mt-[12px]"
            />
          </div>

          <div
            v-if="leaderboardData[2]"
            class="mt-[64px]"
          >
            <div class="relative w-fit mx-auto">
              <img
                :src="top3"
                class="w-[14px] absolute top-[35px] left-1/2 -translate-x-1/2 z-10"
              >
              <img
                :src="avatarNumber1"
                class="w-[56px] mx-auto relative z-0"
              >
              <p class="font-medium text-sm text-center">
                {{ leaderboardData[2].Name }}
              </p>
              <p class="font-medium text-[12px] text-center text-[#29FD88]">
                {{ leaderboardData[2].XP }} {{ t("dashboard.xpLabel") }}
              </p>
            </div>
            <div
              class="w-[100px] h-[280px] bg-gradient-to-b from-[#146DBF] to-[#04427C] rounded-[14px] mt-[12px]"
            />
          </div>
        </div>

        <div
          class="absolute inset-0 bg-black z-20 transition-opacity duration-200 pointer-events-none"
          :style="{ opacity: backdropOpacity }"
        />

        <div
          class="absolute w-full bottom-0 bg-white z-30 rounded-t-[12px] shadow-xl"
          :style="{ height: sheetHeightPx + 'px' }"
        >
          <div
            class="pt-3 pb-4 px-5 select-none cursor-grab active:cursor-grabbing"
            @mousedown="onDragStartMouse"
            @touchstart.passive="onDragStartTouch"
          >
            <div class="w-full">
              <div
                class="mx-auto w-[57px] h-[6px] bg-[#E0E0E0] rounded-[12px]"
              />
            </div>
            <div class="w-full flex justify-between mt-4">
              <p class="text-black font-medium">
                {{ t("ranking.bottomSheet.title") }}
              </p>
              <p class="text-black text-[12px]">
                {{
                  t("ranking.bottomSheet.students", {
                    count: filteredLeaderboard.length,
                  })
                }}
              </p>
            </div>
            <div class="mt-4 flex items-center gap-3">
              <div class="flex-1">
                <div class="relative">
                  <select
                    v-model="selectedSubject"
                    class="w-full appearance-none bg-[#F6F8FA] border border-[#E5E7EB] rounded-[12px] py-2 px-3 text-[12px] text-[#111827]"
                  >
                    <option :value="''">
                      {{ t("ranking.filters.allSubjects") }}
                    </option>
                    <option
                      v-for="s in subjectOptions"
                      :key="s.id"
                      :value="s.id"
                    >
                      {{ s.name }}
                    </option>
                  </select>
                  <span
                    class="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-[#9CA3AF]"
                  >▾</span>
                </div>
              </div>
              <div class="flex-1">
                <div class="relative">
                  <select
                    v-model="selectedLevel"
                    class="w-full appearance-none bg-[#F6F8FA] border border-[#E5E7EB] rounded-[12px] py-2 px-3 text-[12px] text-[#111827]"
                  >
                    <option :value="''">
                      {{ t("ranking.filters.allLevels") }}
                    </option>
                    <option
                      v-for="g in gradeOptions"
                      :key="g.id"
                      :value="g.id"
                    >
                      {{ g.name }}
                    </option>
                  </select>
                  <span
                    class="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-[#9CA3AF]"
                  >▾</span>
                </div>
              </div>
              <button
                class="shrink-0 h-[38px] px-5 rounded-[12px] bg-[#007CEF] text-white text-sm font-semibold disabled:opacity-50"
                :disabled="isLoading"
                @click="refetchWithFilters"
              >
                {{ t("ranking.actions.find") }}
              </button>
            </div>
          </div>

          <div
            class="px-5 overflow-y-auto overscroll-contain"
            :style="{ height: `calc(100% - ${SHEET_HEADER_PX}px)` }"
          >
            <div
              v-if="isLoading"
              class="text-[#6B7280] text-sm"
            >
              {{ t("ranking.list.loading") }}
            </div>
            <div
              v-else-if="!filteredLeaderboard.length"
              class="text-[#6B7280] text-sm"
            >
              {{ t("ranking.list.empty") }}
            </div>
            <div
              v-for="(user, index) in filteredLeaderboard"
              v-else
              :key="user.StudentId"
              class="text-black mt-6"
            >
              <div class="border-[#EDEDED] border-b flex">
                <img
                  :src="[badge1, badge2, badge3][index] || badge1"
                  class="w-[36px] mr-4 mb-4"
                >
                <img
                  :src="avatarNumber1"
                  class="w-[36px] mb-4 mr-4"
                >
                <div>
                  <p class="font-semibold text-[14px]">
                    {{ user.Name }}
                  </p>
                  <p class="font-semibold text-[10px] text-[#007CEF]">
                    {{ user.XP }} {{ t("dashboard.xpLabel") }}
                  </p>
                </div>
              </div>
            </div>
            <div class="h-6" />
          </div>
        </div>

        <div class="z-50 hidden">
          <BottomBarNavigation />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref, watch, computed } from "vue";
import { useI18n } from "vue-i18n";
import BottomBarNavigation from "../base/BottomBarNavigation.vue";
import avatarNumber1 from "../../assets/rank1.png";
import crown from "../../assets/crown.png";
import badge1 from "../../assets/Badge1.png";
import badge2 from "../../assets/Badge2.png";
import badge3 from "../../assets/Badge3.png";
import top1 from "../../assets/top1.png";
import top2 from "../../assets/top2.png";
import top3 from "../../assets/top3.png";
import {
  GlobalAllTimeLeaderboard,
  WeeklyLeaderboard,
} from "@/api/leaderboardApi";
import { QuizListSubject } from "@/api/subjectApi";
import { QuizGradeAll } from "@/api/quizApi";
import SidebarComponent from "../base/SidebarComponent.vue";

const backgroundImage = "/Background-Image.png";
const activeTab = ref("weekly");
const leaderboardData = ref([]);
const isLoading = ref(true);
const { t } = useI18n();

const subjectOptions = ref([]);
const gradeOptions = ref([]);
const selectedSubject = ref("");
const selectedLevel = ref("");
const filteredLeaderboard = computed(() => leaderboardData.value);

const buildLeaderboardFilters = () => {
  const filters = { top: 10 };
  if (selectedSubject.value) {
    const parsed = Number(selectedSubject.value);
    filters.subjectId = Number.isNaN(parsed) ? selectedSubject.value : parsed;
  }
  if (selectedLevel.value) {
    const parsed = Number(selectedLevel.value);
    filters.gradeId = Number.isNaN(parsed) ? selectedLevel.value : parsed;
  }
  return filters;
};

const loadFilterOptions = async () => {
  try {
    const subjects = await QuizListSubject();
    const list = Array.isArray(subjects) ? subjects : subjects?.data ?? [];
    subjectOptions.value = list
      .map((item) => {
        const id = item?.SubjectId ?? item?.Id ?? item?.id ?? null;
        const name =
          item?.SubjectName ??
          item?.name ??
          item?.Name ??
          item?.title ??
          item?.Title ??
          "";
        if (id == null || !name) return null;
        return { id: String(id), name };
      })
      .filter(Boolean);
  } catch {
    subjectOptions.value = [];
  }
  try {
    const grades = await QuizGradeAll();
    const list = Array.isArray(grades) ? grades : grades?.grade ?? [];
    gradeOptions.value = list
      .map((item) => {
        const id =
          item?.Id ?? item?.id ?? item?.GradeId ?? item?.gradeId ?? null;
        const fallbackName =
          id != null ? t("ranking.gradeFallback", { number: id }) : "";
        const name =
          item?.GradeName ?? item?.name ?? item?.Name ?? fallbackName;
        if (id == null || !name) return null;
        return { id: String(id), name };
      })
      .filter(Boolean);
  } catch {
    gradeOptions.value = [];
  }
};

const fetchLeaderboard = async () => {
  isLoading.value = true;
  try {
    const filters = buildLeaderboardFilters();
    if (activeTab.value === "weekly") {
      leaderboardData.value = await WeeklyLeaderboard(filters);
    } else {
      leaderboardData.value = await GlobalAllTimeLeaderboard(filters);
    }
  } catch {
    leaderboardData.value = [];
  } finally {
    isLoading.value = false;
  }
};

const refetchWithFilters = () => {
  fetchLeaderboard();
};

watch(activeTab, () => {
  fetchLeaderboard();
});

const SHEET_MIN_PCT = 35;
const SHEET_MAX_PCT = 85;
const SHEET_INIT_PCT = 50;
const SHEET_HEADER_PX = 170;

const viewportH = ref(typeof window !== "undefined" ? window.innerHeight : 640);
const sheetPct = ref(SHEET_INIT_PCT);
const sheetHeightPx = computed(() =>
  Math.round((viewportH.value * sheetPct.value) / 100)
);
const backdropOpacity = computed(() => {
  const t = (sheetPct.value - SHEET_MIN_PCT) / (SHEET_MAX_PCT - SHEET_MIN_PCT);
  const clamped = Math.max(0, Math.min(1, t));
  return (clamped * 0.6).toFixed(3);
});

let dragging = false;
let startY = 0;
let startPct = SHEET_INIT_PCT;

const clamp = (v, min, max) => Math.min(max, Math.max(min, v));

const onDragStart = (y) => {
  dragging = true;
  startY = y;
  startPct = sheetPct.value;
  document.body.style.overflow = "hidden";
};

const onDragMove = (y) => {
  if (!dragging) return;
  const dy = startY - y;
  const deltaPct = (dy / viewportH.value) * 100;
  sheetPct.value = clamp(startPct + deltaPct, SHEET_MIN_PCT, SHEET_MAX_PCT);
};

const onDragEnd = () => {
  if (!dragging) return;
  dragging = false;
  document.body.style.overflow = "";
};

const onMouseMove = (e) => onDragMove(e.clientY);
const onMouseUp = () => {
  onDragEnd();
  window.removeEventListener("mousemove", onMouseMove);
};

const onTouchMove = (e) => {
  e.preventDefault();
  onDragMove(e.touches[0].clientY);
};
const onTouchEnd = () => {
  onDragEnd();
  window.removeEventListener("touchmove", onTouchMove);
};

const onDragStartMouse = (e) => {
  onDragStart(e.clientY);
  window.addEventListener("mousemove", onMouseMove);
  window.addEventListener("mouseup", onMouseUp, { once: true });
};

const onDragStartTouch = (e) => {
  onDragStart(e.touches[0].clientY);
  window.addEventListener("touchmove", onTouchMove, { passive: false });
  window.addEventListener("touchend", onTouchEnd, { once: true });
};

onMounted(async () => {
  viewportH.value = window.innerHeight;
  await loadFilterOptions();
  await fetchLeaderboard();
  window.addEventListener("resize", () => {
    viewportH.value = window.innerHeight;
  });
});
</script>

<style scoped></style>
